<template>
  <div :class="className">
    <slot />
  </div>
</template>

<script>
  import { ContainerMixin } from 'vue-slicksort';
  export default {
    props: ['className'],
    name: "SortableList",
    mixins: [ContainerMixin],
  }
</script>

<style scoped>
  .drag-list-group {
    max-height: 80vh;
    overflow-y: scroll;
    padding-right: 7px;
    margin-right: -21px;
  }

  .drag-list-group::-webkit-scrollbar {
    width: 10px;
  }

  .drag-list-group::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .drag-list-group::-webkit-scrollbar-thumb {
    background-color: #cacaca;
    border-radius: 5px;
  }
</style>
